module.exports = __webpack_public_path__ + "img/logo.7aa2d805.svg";